import { JoinTaab30Form } from "../Components/Forms/JoinTaab30Form";
import Helmet from "../Components/Helment";

function Coworkwithtab30() {
  return (
    <Helmet title="همکاری با تاب30">
      <div className="mt-5 pt-5 container">
        <div className="card wd-75 wm-100 m-auto container">
          <div className="card-body">
            <p className="fs-4 fw-bold text-center">همکاری با تاب 30</p>
            <hr />
            <p className="p-4 lh-3">
              علاقه مندان به همکاری با تاب سی می‌توانند اطلاعات و رزومه کاری خود
              را در این فرم ثبت و ذخیره کرده تا همکاران ما در واحد منابع انسانی
              بررسی قرار دهند. لطفا به منظور بررسی بهتر درخواست شما، موارد
              خواسته شده را کامل و دقیق تکمیل کنید.
            </p>
            <JoinTaab30Form />
          </div>
        </div>
      </div>
    </Helmet>
  );
}

export default Coworkwithtab30;
